/**
 * Leaves the SPA for a full page navigation (SSO redirects). Wrapped so tests can replace it; the
 * URL is always one the API returned or built by the app, never user input.
 */
export function assignLocation(url: string): void {
  window.location.assign(url);
}
